module.exports = __webpack_public_path__ + "static/media/gopro.234cf0dc.webp";